module.exports = __webpack_public_path__ + "images/questions/qa_question_not_found_bc4aea8425a1ffcbc46a3b6f4ec152c0.png";